import React, { useState, useEffect } from 'react';
import { dateFormatConDiaShort } from '../../../../../utils/DateFunctions';
import v from '../../../../../utils/Verifiers';
const NominasPorEmpleado = (p) => {
    const reportes = p.reportes ?? { datos: [], fechas: [], grupos: [], supervisores: [] };
    const [indexDetalles, setindexDetalles] = useState(-1);
    const [reporteEmpleados, setreporteEmpleados] = useState([]);

    useEffect(() => {
        setindexDetalles(-1);
        reporteEmpleadosMaker();
    }, [p.reportes]);

    const colorAvance = (porcentajeAvance) => {
        if (porcentajeAvance < 50) return '#a91f00';
        if (porcentajeAvance < 80) return '#c36b00';
        if (porcentajeAvance < 90) return '#76a800';
        if (porcentajeAvance > 100) return '#005a70';
        return '#008000';
    }

    const reporteEmpleadosMaker = () => {
        const repSup = {}
        const keys = Object.keys(reportes.grupos);
        const rep = keys.map(k => {
            return totales(reportes.grupos[k]);
        });
        rep.sort((a, b) => a.asignado_a.localeCompare(b.asignado_a));
        setreporteEmpleados(rep);
    }

    const totales = (empleadoData) => {
        let dt = {
            dias_actividades: 0,
            sueldo_primer_turno: 0,
            turnos_1: 0,
            turnos_2: 0,
            bono: 0,
            num_ordenes: 0,
            tipo_empleado: {}
        }
        const fechas = Object.keys(empleadoData.fechas);
        fechas.forEach(fech => {
            const f = empleadoData.fechas[fech];
            dt.num_ordenes += f.ordenes.length;
            dt.tipo_empleado[f.contratista == 0 ? 'EMPLEAADO' : 'CONTRATISTA'] = true;
            dt.turnos_1 += f.nomina.primero;
            dt.turnos_2 += f.nomina.segundo;
            dt.bono += f.nomina.bono;
            dt.dias_actividades += (f.nomina.primero + f.nomina.segundo + f.nomina.bono) > 0 ? 1 : 0;
            dt.sueldo_primer_turno += f.nomina.pago_turno;
        });

        return { ...empleadoData, totales: dt };
    }

    const barraAvanceTurnos = (avance, nombre, helpText) => (
        <div className={`bw-100 p-0 ms-2 me-2`}>
            <div className="w text-s text-300" style={{ '--w': '100%' }}>{nombre}<span className='ms-1 text-xs text-bold'>{helpText}</span></div>
            <div className={`bw-100 round-xxl border text-start p-0 bg-black5`} style={{ overflow: "hidden" }}>
                <div className={`m-0 p-0`} style={{ minHeight: "4px", width: `${avance}%`, backgroundColor: colorPorcentaje(avance), transition: "width 1s ease-in-out", overflow: 'visible' }}></div>
            </div>
        </div>
    )

    const colorPorcentaje = (porcentaje) => {
        if (porcentaje < 20) return '#eb1f00ff';
        if (porcentaje < 45) return '#f09800ff';
        if (porcentaje < 90) return '#ded704ff';
        if (porcentaje < 100) return '#00ae06ff';
        return 'rgba(1, 102, 160, 1)';
    }

    const dibujarBarrasAvanceNomina = (nomina) => {
        return (<div className={`row d-flex m-0 p-0 justify-content-start w-100`}>
            {barraAvanceTurnos(nomina.primero * 100, '1º Turno', +((nomina.primero * 100).toFixed(3)) + '%')}
            {barraAvanceTurnos(nomina.segundo * 100, '2º Turno', +((nomina.segundo * 100).toFixed(3)) + '%')}
            {barraAvanceTurnos(nomina.bono > 0 ? 100 : 0, 'Bono:', '$' + +v.numberFormat(nomina.bono, 2).toFixed(2), '')}
        </div>)
    }

    return (
        <div className='supervisores-reporte-container w-100 dosis mt-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 120px)' }}>
            <div className='row justify-content-around w-100 m-0 p-0'>
                <table className='table table-sm table-borderless bw-1300  text-m' style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                        <tr>
                            <th scope='col'>EMPLEADO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>1ER TURNO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>2DOS TURNO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>BONO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>DÍAS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>NUM. ORDENES</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reporteEmpleados.map((sup, index) => {
                                const tdClass = "border-top pointer";
                                const opacity = indexDetalles === -1 || indexDetalles === index ? 100 : 30;
                                const cumplimiento = +(sup.horas_asignadas === 0 ? 0 : (sup.horas_realizadas / sup.horas_asignadas * 100).toFixed(2));
                                return (<React.Fragment key={index + "superv"}>
                                    <tr className={`opacity-${opacity}`} onClick={() => {
                                        if (indexDetalles === index) {
                                            setindexDetalles(-1);
                                        } else {
                                            setindexDetalles(index);
                                        }
                                    }}>
                                        <td scope='row' className={`bg-transparent text-bold ps-3 ${tdClass}`}>{sup.asignado_a} - {sup.asignado_a_id}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{+sup.totales.turnos_1.toFixed(2)}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{+sup.totales.turnos_2.toFixed(2)}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>${sup.totales.bono.toFixed(2)}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.totales.dias_actividades}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.totales.num_ordenes}</td>
                                    </tr>
                                    {indexDetalles === index && <tr>
                                        <td colSpan={6} >
                                            <div className='row justify-content-end'>
                                                <div className='bw-1200'>
                                                    <table className='table table-sm text-s'>
                                                        <thead>
                                                            <tr className='text-xs'>
                                                                <th>SUPERVISOR</th>
                                                                <th>RANCHO</th>
                                                                <th>ÁREA</th>
                                                                <th>LABOR</th>
                                                                <th>ASIGNADO</th>
                                                                <th>REALIZADO</th>
                                                                <th className="text-right">PAGO P/ UNIDAD</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.keys(sup.fechas).map((fech, fIndex) => {
                                                                const d = sup.fechas[fech];
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td colSpan={7} className='text-bold text-s pt-3 pb-0'>
                                                                                {dateFormatConDiaShort(fech)}
                                                                            </td>
                                                                        </tr>
                                                                        {d.ordenes.map((ord, oIndex) => <tr key={fIndex + "sud" + oIndex} style={{ fontSize: '12px' }}>
                                                                            <td scope='row'>{ord.asignado_por}</td>
                                                                            <td>{ord.rancho_nombre}</td>
                                                                            <td>{ord.area_nombre}</td>
                                                                            <td>{ord.labor_nombre}</td>
                                                                            <td>{ord.unidades_asignadas} <span className="text-xs">{ord.um_nombre}</span> / {+(ord.unidades_asignadas * ord.ms_por_unidad / 3600000).toFixed(3)} <span className="text-xxs">Hrs.</span></td>
                                                                            <td>{ord.unidades_realizadas} <span className="text-xs">{ord.um_nombre}</span> / {+(ord.unidades_realizadas * ord.ms_por_unidad / 3600000).toFixed(3)} <span className="text-xxs">Hrs.</span></td>
                                                                            <td className="text-right">${(ord.pago_unidad).toFixed(2)}</td>
                                                                        </tr>
                                                                        )}
                                                                        <tr style={{ fontSize: '11px' }} className='text-bold'>
                                                                            <td style={{ border: "none" }}>TOTALES</td>
                                                                            <td style={{ border: "none" }} colSpan={3}>{dibujarBarrasAvanceNomina(d.nomina)}</td>
                                                                            <td style={{ border: "none" }}></td>
                                                                            <td style={{ border: "none" }}></td>
                                                                            <td style={{ border: "none" }}></td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table >
                                                </div>
                                            </div>

                                        </td>
                                    </tr>}
                                </React.Fragment>
                                )
                            })}
                    </tbody>
                </table>
                <div className='col-lg-12 mt-5 mb-5 p-5'></div>
            </div>
        </div>
    )
}

export default NominasPorEmpleado;